import { useEffect } from 'react';

import { useCookies } from '../context/cookies-context';
import { cookieSettingsStore } from '../storage/cookie-settings';
import { isGtmEnabled, updateGtmConsent } from '../utils/gtm.util';

export const useGtmConsent = () => {
  useEffect(() => {
    if (!isGtmEnabled()) return;

    const storedSettings = cookieSettingsStore.get();

    if (storedSettings) {
      updateGtmConsent(storedSettings);
    }

    return useCookies.subscribe((state, prevState) => {
      if (state.cookieSettings === prevState.cookieSettings) return;

      updateGtmConsent(state.cookieSettings);
    });
  }, []);
};
